module.exports = __webpack_public_path__ + "static/media/amex.7d284eaa.png";